import Navbar from "./Navbar2";

export default Navbar;
